import React from 'react';

interface ProLoadingOverlayProps {
  thumbnailUrl?: string;
  text?: string;
}

export const ProLoadingOverlay: React.FC<ProLoadingOverlayProps> = ({
  thumbnailUrl,
  text = 'Chargement du projet...',
}) => {
  return (
    <div className="pro-loading-overlay">
      <div className="pro-loading-overlay__content">
        {thumbnailUrl && (
          <img
            src={thumbnailUrl}
            alt=""
            className="pro-loading-overlay__thumb"
          />
        )}
        <div className="pro-loading-overlay__spinner" />
        <div className="pro-loading-overlay__text">{text}</div>
      </div>
    </div>
  );
};

